module.exports = __webpack_public_path__ + "img/icon-plus.fd590134.svg";